module.exports = __webpack_public_path__ + "media/images/store/galaxy_store-027a270acf25ff73870d7c49dda7cec5.png";